var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPontisGlobalLogoMarkOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.81,
    height: 96.23,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 137.81 96.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 105.5,
    y1: 15.72,
    x2: 34.76,
    y2: 78.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f47820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15e24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M111.67,26.11c-6.27-12.18-17.67-21.61-32.06-24.89-24.34-5.56-48.58,8.42-56.32,31.63,27.26-10.49,57.77-13.39,88.38-6.73ZM123.11,57.42c7.21,7.9,10.38,14.97,7.97,19.71-2.89,5.68-13.22,6.86-27.33,4.15,5.78-6.06,10.05-13.7,12.05-22.46,2.24-9.83,1.27-19.64-2.19-28.36-19.44,6.87-37.09,18.12-51.57,32.81,8.84,6.31,18.69,11.35,18.69,11.35,0,0-10.55-3.78-20.72-9.26C26.31,48.21,3.4,25.66,8.83,14.98c2.41-4.74,9.99-6.34,20.62-5.17C14.48,6.78,3.67,7.76.76,13.47c-5.57,10.95,19.98,35.12,57.16,54.19-5.72,6.34-10.88,13.24-15.36,20.66,4.65,3.06,9.89,5.38,15.64,6.69,15.5,3.54,30.95-.85,42.14-10.49,19.07,5.13,33.31,4.93,36.71-1.76,2.9-5.71-2.67-15.03-13.94-25.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPontisGlobalLogoMarkOnly);
export default __webpack_public_path__ + "static/media/Pontis Global Logo - Mark Only.4edfd66276c50f9fa70aab841d9ebb50.svg";
export { ForwardRef as ReactComponent };